import { DM_URN_TYPE } from '../constants/attachment-types';

export const filterCurrentDocument = (data, targetUrn) => {
  if (!targetUrn) {
    return data;
  }

  const result = Object.assign({}, data);
  result.documents = data.documents.filter(d => targetUrn !== d.urn);
  return result;
};

export const imageExtensionMimeTypeMapping = {
  'jpg': 'image/jpeg',
  'jpeg': 'image/jpeg',
  'png': 'image/png',
};
export const imageExtensions = Object.keys(imageExtensionMimeTypeMapping);
const getExtension = fileName => fileName.split('.').pop().toLowerCase();

const isImageFilename = (fileName) => {
  if (!fileName) {
    return false;
  }
  const extension = getExtension(fileName);
  return imageExtensions.includes(extension);
};

export const getMimeType = (url) => {
  if (!url) {
    return '';
  }
  else {
    const extension = getExtension(url);
    return imageExtensionMimeTypeMapping[extension] || '';
  }
};

export const isImageAttachment = (attachment) => {
  return isImageFilename(attachment.name) || isImageFilename(attachment.url);
};

export const isDocsAttachment = (attachment) => {
  return attachment.urnType === DM_URN_TYPE;
};

/**
 * This method returns true if a pushpin can be added to document.
 * We can remove this method once https://git.autodesk.com/BIM360/dm-sdk-js/issues/53 is resolved.
 * @param document
 * @returns {boolean}
 */
export const isSupportPushpin = (document) => {
  if (isImageFilename(document.fileName)) {
    return false;
  }
  if (!document.currentVersion.bubbleUrn) {
    return false;
  }
  const entityType = document.currentVersion.entityType;
  // eslint-disable-next-line default-case
  switch (entityType) {
    case 'DOCUMENT':
      return true;
    case 'SEED_FILE':
      if (document.currentVersion.processState) {
        if (document.currentVersion.processState !== 'PROCESSING_COMPLETE') {
          return false;
        }
        if (document.currentVersion.extractionState === 'SUCCESS') {
          return true;
        }
        if (document.currentVersion.partialExtractionFailure === true) {
          return true;
        }
      }
      return false;
  }
  return false;
};

export const filterPushpinSupportDocuments = (data) => {
  const result = Object.assign({}, data);
  result.documents = data.documents.filter(d => isSupportPushpin(d));
  return result;
};

// Return an array of file extensions accepted per issue type.
// Empty string means all files are allowed.
export const getAllowedFiles = () => {
  return '';
};
